import styled from 'styled-components';

export const CarouselContainer = styled.div`
  position: relative;
  background: url('https://images.myloapp.in/NestJsUploads/1697450118361-Semi-curve-grey.svg');
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  padding-top: 30px;
  margin-bottom: 30px;

  background-size: cover;

  & .slider {
    padding-top: 3% !important;
  }
  & .carousel .slider-wrapper {
    padding-bottom: 20px;

    .imageContainer {
      background: none;
      background-position: none;

      cursor: pointer;
      height: auto !important;
      img {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
        padding-top: 35%;
      }
    }
    .selected {
      transform: none !important;

      .imageContainer {
        width: 65% !important;
        position: relative !important;

        text-shadow: 0 0 1px #000;
        height: auto !important;

        :after,
        :before {
          content: '';
          display: ${(props) => (props.newReviews ? 'none' : 'block')};
          position: absolute;
          left: 100%;
          width: 0;
          height: 0;
          border-style: solid;
        }

        :after {
          top: 0%;
          border-color: transparent #ededed transparent transparent;
          border-width: 150px 26px;
          left: 81%;
        }

        :before {
          top: 0%;
          border-color: transparent transparent transparent #ededed;
          border-width: 150px 26px;
          left: -2%;
        }

        img {
          border-radius: ${(props) =>
            props.newReviews ? '5%' : '15%'}!important;
          filter: none;
          padding-top: 0%;
        }
      }
    }

    li {
      display: flex;
      align-items: center;
    }
  }
  .rotateClock {
    transform: rotate(10deg);
  }
  .rotateAntiClock {
    transform: rotate(-10deg);
  }

  & .carousel img {
    width: 100%;
    height: auto;
    display: inline-block;
    pointer-events: none;
    border-radius: 4px;
  }
  & .control-dots {
    top: 150% !important;
    @media (max-width: 768px) {
      top: ${(props) => (props.newReviews ? '140%' : '160%')} !important;
    }
  }
  .carousel .control-dots .dot {
    box-shadow: none !important;
  }
  .carousel .control-dots .dot {
    background: #c0b3b0 !important;
    width: 10px !important;
    height: 10px !important;
  }
  .carousel .control-dots .dot.selected {
    background: rgb(96, 69, 72) !important;
    width: 30px !important;
    height: 10px !important;
  }
  & .carousel-slider {
    margin-bottom: 0 !important;
  }
  .headingSection {
    padding-top: 5%;
    text-align: center;
    .heading {
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
    }
    .description-our-philosophy {
      font-size: clamp(25px, 2vw, 40px);
      font-weight: 600;
      color: rgba(0, 0, 0, 0.7);
      align-items: center;
      width: 100%;
      margin-bottom: 10px;
    }
  }
`;
export const ImageOuter = styled.div`
  background: none !important;
  background-position: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: auto !important;
`;

export const TextContainerOuter = styled.div`
  // background: rgb(234, 243, 244) !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5%;
`;

export const TextContainer = styled.div`
  height: auto !important;
  width: 30%;
  @media (max-width: 720px) {
    width: 100%;
  }
  text-align: center;
  .name {
    color: #96898b;
    font-weight: 600;
    text-transform: uppercase;
    padding-bottom: 20px;
  }
  .desc {
    color: #c7b3b7;
    font-weight: 500;
    min-height: ${(props) => (props.newReviews ? '140px' : '180px')};
    font-size: 16px;
    padding: 0 20px;
  }
`;

export const ButtonContainer = styled.div`
  width: fit-content;
  background: #ef4e5e !important;
  color: rgb(248, 170, 178);
  text-align: center;
  padding: 16px 30px;
  height: auto !important;
  font-size: 12px;
  border-radius: 30px !important;
  margin: 16px auto 0;
`;
